// Core packages
import { OnInit } from "@angular/core";
// Third party packages
import { MatDialogRef } from "@angular/material/dialog";
/**
 * Destination picker of a move, shared by the section move (level 2 -> another area)
 * and the document move (level 3 -> another section).
 *
 * The dialog IS the confirmation step: the consequence of the move is stated inside
 * it and the primary button confirms, so the user never picks a destination in one
 * place and confirms something else in another (the legacy page keeps a page level
 * form whose value survives a change of selection).
 *
 * Closes with the chosen destination id, or with undefined when cancelled.
 *
 * @since 3.0.0
 */
var DocumentTemplateMoveDialogComponent = /** @class */ (function () {
    /**
     * Class constructor
     */
    function DocumentTemplateMoveDialogComponent(dialogRef, data) {
        this.dialogRef = dialogRef;
        this.data = data;
        this.selectedValue = "";
        this.search = "";
        this.visibleGroups = [];
    }
    /**
     * Init component
     *
     * @since 3.0.0
     */
    DocumentTemplateMoveDialogComponent.prototype.ngOnInit = function () {
        this.applySearch();
    };
    /**
     * Filter the destinations by label or identifier, dropping the groups left empty.
     *
     * @since 3.0.0
     */
    DocumentTemplateMoveDialogComponent.prototype.applySearch = function () {
        var groups = this.data && Array.isArray(this.data.groups) ? this.data.groups : [];
        var query = (this.search || "").trim().toLowerCase();
        if (!query) {
            this.visibleGroups = groups.filter(function (group) { return group.options && group.options.length > 0; });
            return;
        }
        var filtered = [];
        groups.forEach(function (group) {
            var options = (group.options || []).filter(function (option) {
                return (option.label || "").toLowerCase().indexOf(query) >= 0 ||
                    (option.hint || "").toLowerCase().indexOf(query) >= 0;
            });
            if (options.length) {
                filtered.push({ label: group.label, options: options });
            }
        });
        this.visibleGroups = filtered;
    };
    Object.defineProperty(DocumentTemplateMoveDialogComponent.prototype, "hasDestinations", {
        /**
         * True when there is no destination at all to pick from.
         *
         * @since 3.0.0
         */
        get: function () {
            var groups = this.data && Array.isArray(this.data.groups) ? this.data.groups : [];
            return groups.some(function (group) { return group.options && group.options.length > 0; });
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Confirm the move.
     *
     * @since 3.0.0
     */
    DocumentTemplateMoveDialogComponent.prototype.onConfirm = function () {
        if (!this.selectedValue) {
            return;
        }
        this.dialogRef.close(this.selectedValue);
    };
    /**
     * Dismiss without moving anything.
     *
     * @since 3.0.0
     */
    DocumentTemplateMoveDialogComponent.prototype.onClose = function () {
        this.dialogRef.close();
    };
    return DocumentTemplateMoveDialogComponent;
}());
export { DocumentTemplateMoveDialogComponent };
